import axios from "axios";

export const api = axios.create({
  baseURL: "https://api.easypoint.app.br/",
  // baseURL: "https://apihml.easypoint.app.br/",
});

export default api;
